// src/pages/More.js
import React from "react";

function More() {
  return (
    <div style={{ padding: "20px" }}>
      <h2>More</h2>
      <p>Placeholder for more content</p>
    </div>
  );
}

export default More;